import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';

import { TenantDataService } from '@services/data/tenant-data.service';
import { StationInboxComponent } from '@station/inbox/station-inbox.component';

@Component({
    selector: 'app-station-inbox-page',
    templateUrl: 'station-inbox.page.component.html',
    styleUrl: 'station-inbox.page.component.scss',
    imports: [StationInboxComponent, AsyncPipe],
})
export class StationInboxPageComponent {
    private readonly tenantDataService = inject(TenantDataService);

    currentTenant$ = this.tenantDataService.currentTenant$;
}
